import { Paper, Typography, styled, Theme, ButtonBase, IconButton } from '@material-ui/core';
import { SvgIcon, LocalLoading, BlankButton } from '../../../shared/components';

export const SubjectWrapper = styled(Paper)<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '-0.3rem',
  left: '1.5rem',
  padding: theme.spacing(1, 2),
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.bodySm.fontSize,
  color: theme.palette.grey['700'],
  textTransform: 'uppercase',
}));

export const TrajectoryTitle = styled(Typography)<Theme>(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(2),
  fontSize: theme.typography.body1.fontSize,
  paddingLeft: theme.spacing(3),
}));

export const StyledIcon = styled(SvgIcon)({
  position: 'absolute',
  left: 0,
});

export const IconButtonsWrapper = styled('div')({
  position: 'absolute',
  top: '1rem',
  right: '1rem',
});

export const StyledIconButton = styled(IconButton)<Theme>(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  marginLeft: theme.spacing(1),
  padding: theme.spacing(1),
}));

export const StyledBookFilter = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '2.5rem',
  right: '2rem',
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  borderRadius: theme.config.defaultBorderRadius,
}));

export const AssignmentsWrapper = styled('div')({
  overflowY: 'auto',
  margin: '0 -2rem 3rem -2rem',
  padding: '0 2rem',
});

export const TitleWrapper = styled(BlankButton)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});

export const Spacer = styled('div')<Theme>(({ theme }) => ({
  flex: 1,
  borderBottom: '1px dashed rgba(0, 0, 0, 0.12)',
  margin: theme.spacing(0, 2),
}));

export const StyledLocalLoading = styled(LocalLoading)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  display: 'block',
  top: 0,
  right: theme.spacing(4),
  padding: theme.spacing(0, 2),
  position: 'absolute',
}));

export const ContentWrapper = styled('div')({
  paddingBottom: '1rem',
});

export const Wrapper = styled('div')<Theme, { color: string }>(({ theme, color }) => ({
  position: 'relative',
  marginTop: theme.spacing(4),
  padding: '4rem 1rem 1rem 1.5rem',
  backgroundColor: color,
  borderRadius: '1rem',
}));

export const ButtonWrapper = styled(ButtonBase)(({ theme }) => ({
  position: 'absolute',
  top: '1.5rem',
  right: '1.5rem',
  border: `1px solid ${theme.palette.primary.main}`,
  fontFamily: theme.config.primaryFontFamily,
  color: theme.palette.primary.main,
  fontWeight: 700,
  borderRadius: '1rem',
  padding: '0 0.5rem 0 1rem',
  backgroundColor: theme.palette.common.white,
}));
